import {
  ContentState,
  EditorState,
  convertFromHTML as draftConvertFromHTML,
  convertToRaw,
} from 'draft-js';
import draftToHtml from 'draftjs-to-html';

const toDraftReadableHtml = (html: string): string =>
  html.replace(/<ins(\s[^>]*)?>/gi, '<u>').replace(/<\/ins>/gi, '</u>');

export const htmlToEditorState = (html: string): EditorState => {
  if (!html) return EditorState.createEmpty();

  const blocks = draftConvertFromHTML(toDraftReadableHtml(html));
  if (!blocks.contentBlocks || blocks.contentBlocks.length === 0) {
    return EditorState.createEmpty();
  }

  return EditorState.createWithContent(
    ContentState.createFromBlockArray(blocks.contentBlocks, blocks.entityMap),
  );
};

export const editorStateToHtml = (editorState: EditorState): string =>
  draftToHtml(convertToRaw(editorState.getCurrentContent()));

export const stripHtml = (html: string): string =>
  html
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/\s+/g, ' ')
    .trim();
